import { convertUnit, getDimensionForUnit, SCALAR_UNIT, TIMESTAMP_UNIT_SECONDS, } from "../unit-system";
/**
 * Unary `duration → duration expressed in `targetUnit``. Accepts only a
 * Time-dimension scalar (s/min/h/d, or a timestamp difference which is `s`);
 * an absolute timestamp or a unitless/non-time value is rejected so a wrong
 * magnitude can never slip through silently.
 */
class TimeConversionFunction {
    name;
    targetUnit;
    signature;
    constructor(name, targetUnit, description) {
        this.name = name;
        this.targetUnit = targetUnit;
        this.signature = {
            name,
            parameters: [
                {
                    name: "duration",
                    type: "scalar",
                    description: "A time duration (s/min/h/d, or a timestamp difference)",
                },
            ],
            returnType: "scalar",
            description,
            examples: [`${name}(row.end - row.start)`],
            category: "time",
        };
    }
    execute(args, context) {
        const arg = args[0];
        const unit = arg.unit ?? SCALAR_UNIT;
        if (unit === TIMESTAMP_UNIT_SECONDS) {
            return context.createError("InvalidArgumentType", `${this.name}() expects a time duration, not an absolute timestamp. Subtract two timestamps to get a duration first.`);
        }
        if (getDimensionForUnit(unit) !== "Time") {
            return context.createError("InvalidArgumentType", `${this.name}() expects a time duration (s/min/h/d), but got a value with unit "${unit}".`);
        }
        return {
            type: "scalar",
            value: convertUnit(arg.value, unit, this.targetUnit),
            unit: this.targetUnit,
        };
    }
}
export const timeFunctions = [
    new TimeConversionFunction("seconds", "s", "Express a time duration in seconds"),
    new TimeConversionFunction("minutes", "min", "Express a time duration in minutes"),
    new TimeConversionFunction("hours", "h", "Express a time duration in hours"),
    new TimeConversionFunction("days", "d", "Express a time duration in days"),
];
//# sourceMappingURL=time-functions.js.map